import { defaultColumns } from '@/angularBridgeCode/services/WebhookService';

export default {
  webhooks: [],
  columns: defaultColumns,
  userVisibleColumns: defaultColumns,
  currentAccountFeatureFlags: {},
  status: {},
};